/**
 * List of events used by excursions widget
 * @type {Object.<string, string>}
 */
export const excursions = {
  EXCURSION_CLICKED: 'excursions.excursionClicked',
  SEE_MORE_EXCURSIONS_CLICKED: 'excursions.seeMoreExcursionsClicked'
}
